var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.leaf
    ? _c(
        "el-menu-item",
        {
          staticClass: "report-sub-item-leaf",
          attrs: { index: _vm.item.id },
          on: {
            click: function($event) {
              return _vm.onClick(_vm.item)
            }
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c("span", { staticClass: "el-icon-tickets" }, [
              _vm._v(" " + _vm._s(_vm.getNameByLanguage(_vm.item)))
            ])
          ])
        ],
        2
      )
    : _c(
        "el-submenu",
        {
          class: "report-sub-item report-sub-item-" + _vm.level,
          attrs: { index: _vm.item.id }
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "span",
              {
                staticClass: "el-icon-folder",
                style: {
                  paddingLeft: _vm.level === 2 ? "40px" : "",
                  color: _vm.level === 1 ? "#000000" : "#666666"
                }
              },
              [_vm._v(" " + _vm._s(_vm.getNameByLanguage(_vm.item)))]
            )
          ]),
          _vm._l(_vm.item.exploreList, function(report) {
            return [
              _c("report-sub-item", {
                key: report.id,
                attrs: { item: report, level: _vm.level + 1 },
                on: { click: _vm.onClick }
              })
            ]
          })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }